/**
 * Section: Featured In Slider
 */

(function() {
  'use strict';

  const whenVisible = window.theme?.whenVisible || ((element, callback) => callback(element));

  function initFeaturedInSliders(element) {
    const sliders = element.querySelectorAll('.featured-in__slider');
    
    sliders.forEach(function(slider) {
      if (slider.dataset.swiperInitialized === 'true') return;
      
      window.loadThemeSwiper().then(() => {
        const swiper = new Swiper(slider, {
          slidesPerView: 2,
          spaceBetween: 30,
          loop: true,
          freeMode: true,
          freeModeMomentum: false,
          autoplay: {
            delay: 500,
            disableOnInteraction: false,
          },
          speed: 800,
          breakpoints: {
            480: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          },
        });
        
        slider.dataset.swiperInitialized = 'true';
      }).catch((error) => {
        console.warn('Swiper failed to load for FeaturedIn:', error);
      });
    });
  }

  window.initFeaturedInSliders = initFeaturedInSliders;

  if (!customElements.get('featured-in-section')) {
    class FeaturedInSection extends HTMLElement {
      connectedCallback() {
        this.visibilityObserver = whenVisible(this, () => initFeaturedInSliders(this));
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect?.();
      }
    }
    customElements.define('featured-in-section', FeaturedInSection);
  }
})();
